// Activity types + priorities (see db-design/01_prospects_schema.sql `activities`).
export const activityTypes = [
  { id: "appointment", name: "Appointment" },
  { id: "follow_up_call", name: "Follow-up call" },
  { id: "task", name: "Task" },
  { id: "auction", name: "Auction" },
  { id: "letter", name: "Letter" },
  { id: "birthday", name: "Birthday" },
  { id: "close_date", name: "Close date" },
];

export const activityPriorities = [
  { id: "low", name: "Low" },
  { id: "normal", name: "Normal" },
  { id: "high", name: "High" },
];

export const activityTypeLabel = (type?: string | null) =>
  activityTypes.find((t) => t.id === type)?.name ?? type ?? "";
